/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type EvalSuiteDeletedObject = {
  id: string;
  object: "eval.suite.deleted";
  deleted: boolean;
  deletedRuns: number;
};

/** @internal */
export const EvalSuiteDeletedObject$inboundSchema: z.ZodType<
  EvalSuiteDeletedObject,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  object: z.literal("eval.suite.deleted"),
  deleted: z.boolean(),
  deleted_runs: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "deleted_runs": "deletedRuns",
  });
});
/** @internal */
export type EvalSuiteDeletedObject$Outbound = {
  id: string;
  object: "eval.suite.deleted";
  deleted: boolean;
  deleted_runs: number;
};

/** @internal */
export const EvalSuiteDeletedObject$outboundSchema: z.ZodType<
  EvalSuiteDeletedObject$Outbound,
  z.ZodTypeDef,
  EvalSuiteDeletedObject
> = z.object({
  id: z.string(),
  object: z.literal("eval.suite.deleted"),
  deleted: z.boolean(),
  deletedRuns: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    deletedRuns: "deleted_runs",
  });
});

export function evalSuiteDeletedObjectToJSON(
  evalSuiteDeletedObject: EvalSuiteDeletedObject,
): string {
  return JSON.stringify(
    EvalSuiteDeletedObject$outboundSchema.parse(evalSuiteDeletedObject),
  );
}
export function evalSuiteDeletedObjectFromJSON(
  jsonString: string,
): SafeParseResult<EvalSuiteDeletedObject, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EvalSuiteDeletedObject$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EvalSuiteDeletedObject' from JSON`,
  );
}
